/**
 * Dealer Manage : 经销商管理
 */

import { generate } from '@/utils/request';
const config = {
  prefix: '/spfm/v1/{organizationId}',
  items: [
    /**
     * 根据lovCode查询单个值集头
     */
    {
      key: 'getLovHeadersByLovCode',
      url: '/lov-headers-code/{lovCode}',
      method: 'GET',
      loadingHide: true,
    },

    /**
     * 根据值集头ID分页查询值集值
     */
    {
      key: 'getLovValuesByLovId',
      url: '/lov-headers/{lovId}/values',
      method: 'GET',
      loadingHide: true,
    },
    /**
     * 批量删除值集值
     */
    { key: 'deleteLovValues', url: '/lov-values', method: 'DELETE' },

    /**
     * 插入值集值
     */
    { key: 'addLovValues', url: '/lov-values', method: 'POST' },

    /**
     * 更新值集值
     */
    { key: 'updateLovValues', url: '/lov-values', method: 'PUT' },

    /**
     * 获取值集头
     */
    { key: 'getlovHeadersPage', url: '/lov-headers', method: 'GET',loadingHide: true, },
    /**
     * 新增值集头
     */
    { key: 'addlovHeaders', url: '/lov-headers', method: 'POST',loadingHide: true, },
    /**
     * 修改值集头
     */
    { key: 'updatelovHeaders', url: '/lov-headers', method: 'PUT',loadingHide: true, },
    /**
     * 删除值集头
     */
    { key: 'deletelovHeaders', url: '/lov-headers', method: 'DELETE',loadingHide: true, },

    /**
   * 查询值集数据
   */
  {
    key: 'getLovView',
    url: '/lov-view/info?viewCode={viewCode}',
    method: 'GET',
  },

  /**
   * 查询值集数据
   */
  { key: 'getLovSqlData', url: '/lovs/sql/data', method: 'GET' },
  ],
};

export default {
  ...generate(config),
};
